import {
  ICreateManualProductOrderRequest,
  ICreateManualProductOrderResponse,
  IProductOrder,
  PaymentMethod,
  ProductOrderStatusEnum
} from '@torim-app/types';
import { adminUrlBuilder } from '@app/api/utils';

export class ProductOrdersApi {
  static readonly path = 'product-orders';

  static async getOrders(filters?: { status?: string; branchId?: string }): Promise<IProductOrder[]> {
    const queryParams: Record<string, string> = {};
    if (filters?.status) queryParams.status = filters.status;
    if (filters?.branchId) queryParams.branchId = filters.branchId;

    const url = adminUrlBuilder(queryParams, ProductOrdersApi.path);
    const response = await fetch(url, {
      method: 'get',
      headers: {
        'content-type': 'application/json'
      }
    });
    if (!response.ok)
      throw `Failed to fetch product orders`;
    return await response.json();
  }

  static async getOpenOrdersCount(): Promise<{ count: number }> {
    const url = adminUrlBuilder({}, `${ProductOrdersApi.path}/open-count`);
    const response = await fetch(url, {
      method: 'get',
      headers: {
        'content-type': 'application/json'
      }
    });
    if (!response.ok)
      throw `Failed to fetch open orders count`;
    return await response.json();
  }

  static async createManualSale(body: ICreateManualProductOrderRequest): Promise<ICreateManualProductOrderResponse> {
    const url = adminUrlBuilder({}, `${ProductOrdersApi.path}/manual`);
    const response = await fetch(url, {
      method: 'post',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok)
      throw `Failed to create manual sale`;
    return await response.json();
  }

  static async collectManualSalePayment(orderId: string, paymentMethod: PaymentMethod, useCustomerBalance?: boolean): Promise<{ settled: 'link-sent' | 'paid' }> {
    const url = adminUrlBuilder({}, `${ProductOrdersApi.path}/${orderId}/payment`);
    const response = await fetch(url, {
      method: 'post',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({ paymentMethod, useCustomerBalance })
    });
    if (!response.ok)
      throw `Failed to collect manual sale payment`;
    return await response.json();
  }

  static async updateStatus(orderId: string, status: ProductOrderStatusEnum): Promise<IProductOrder> {
    const url = adminUrlBuilder({}, `${ProductOrdersApi.path}/${orderId}/status`);
    const response = await fetch(url, {
      method: 'put',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({ status })
    });
    if (!response.ok)
      throw `Failed to update order status`;
    return await response.json();
  }
}
